import { memo, useCallback } from "react";
import { Notification } from "./Notification";
import random from "lodash/random";

interface NotificationsProviderProps {
  notifications: Array<{
    id?: string | number;
    type?: string;
    title?: string;
    message?: string;
    [key: string]: any;
  }>;
  children: React.ReactNode;
  onNotificationClick: (id: string | number) => void;
}

export const NotificationsProvider = memo(({
  notifications = [],
  children,
  onNotificationClick,
}: NotificationsProviderProps) => {
  // Use a consistent callback to prevent recreation on each render
  const handleNotificationClick = useCallback((notificationId: string | number) => {
    onNotificationClick(notificationId);
  }, [onNotificationClick]);

  return (
    <div className="relative">
      {children}
      <div className="w-90vw lg:w-md pointer-events-none fixed right-0 top-0 z-50 h-screen pr-8 pt-8">
        <>
          {notifications?.map((notification) => {
            // Generate ID once and use it consistently
            const notificationId = notification.id || random();
            return (
              <Notification
                key={notificationId}
                onClick={() => handleNotificationClick(notificationId)}
                {...notification}
              />
            );
          })}
        </>
      </div>
    </div>
  );
});

NotificationsProvider.displayName = "NotificationsProvider";
